export const enum ContactTypeEnum {
  PreLead = 1,
  Customer = 225360001,
  Investor = 225360002,
}
